import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, Redirect } from 'react-router-dom';
import { push } from "connected-react-router";
import { Alert, Row, Col, Button, Container, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { isMobile, isTablet } from "react-device-detect";
import FullPageLoader from '../../components/loaders/FullPageLoader/FullPageLoader';
import HomeLine from './HomeLine';
import IndividualProject from './IndividualProject';
import * as actions from '../actions';
import './HomePage.css';
import HomeGooglePlay from './HomeGooglePlay';
import GoodsItem from './GoodsItem';
import ElementItem from './ElementItem';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import Helper from '../../utils/helper';
import { sendAmplitudeData, amplitudeTypes } from '../../utils/amplitude';
import HomeFAQ from './HomeFAQ';
import { getManufacturers } from '../../manufacturer/actions';
import ManufacturerItem from '../../manufacturer/ManufacturerItem';
import { MdPhone } from 'react-icons/md';

import { addFavorites, removeFavorites, loadFavoriteLocal } from '../../favorites/actions';
import '../catalogv23/CatalogPage.css';
import ProductCard from '../catalogv23/ProductCard';

class HomePage extends React.Component {
    static DemoSessionTime = 20 * 60 * 1000;

    constructor(props) {
        super(props);
        this.state = {
            redirectToProjects: false,
            redirectToGoods: false,
            redirectToElements: false,
            showAfterDemoPopup: false,
            loading: false,
            videoCode1: ''
        };
    }

    componentDidMount() {
        this.props.getHomeData();
        this.props.getInfoVideo('MainPageVideo1', (code) => {
            this.setState({
                videoCode1: code
            });
        });
        this.props.getManufacturers(3);
    }

    onIndividualProjectClick = (typeKey) => {
        this.setState({
            redirectToProjects: true
        });
        sendAmplitudeData(amplitudeTypes.CLICK_MORE_PRODUCTS, null);
    }

    onDemoEditor = () => {
        if (this.editorWindow != null) {
        } else {
            this.setState({
                loading: true
            });
            this.props.makeDemoProduct((isOk, product) => {
                this.setState({
                    loading: false
                });
                if (isOk) {
                    sendAmplitudeData(amplitudeTypes.OPEN_DEMO_EDITOR, null);

                    let editorLink = window.location.protocol + '//editor.' + window.location.host + '?productId=' + product.id;
                    this.editorWindow = window.open(editorLink, '_blank');                    
                    if (!this.props.isAuthenticated) {
                        this.startEditorTimer();
                        Helper.saveDemoProductId(product);
                    }
                } else {
                    toastr.error('', this.props.t('errorDataLoad'));
                }
            });
        }
    }

    startEditorTimer = () => {
        setTimeout(() => {
            this.onDemoFinish();
        }, HomePage.DemoSessionTime);

        let timer = setInterval(() => {
            if (this.editorWindow == null) {
                clearInterval(timer);
            }
            if (this.editorWindow.closed) {
                clearInterval(timer);
                this.onDemoFinish();
            }
        }, 1000);
    }

    onDemoFinish = () => {
        if (this.editorWindow != null) {
            this.editorWindow.close();
            this.editorWindow = null;
            if (!this.props.isAuthenticated) {
                this.setState({
                    showAfterDemoPopup: true
                });
            }
        }
    }

    hideAfterDemoPopup = () => {
        this.setState({
            showAfterDemoPopup: false
        });
    }

    onCreateProjectAfterDemo = () => {
        sendAmplitudeData(amplitudeTypes.CLICK_PROJECT_CREATE_DEMO, null);
    }

    cancelAfterDemo = () => {
        this.hideAfterDemoPopup();
        sendAmplitudeData(amplitudeTypes.CLICK_PROJECT_CANCEL_DEMO, null);
    }

    onCreateProject = () => {
        sendAmplitudeData(amplitudeTypes.CLICK_PROJECT_CREATE_HOMEPAGE, null);
    }

    onGoodsItemClick = (item) => {
        sendAmplitudeData(amplitudeTypes.CLICK_MORE_GOODS, null);
        this.setState({
            redirectToGoods: true
        });
    }

    onElementClick = (item) => {
        sendAmplitudeData(amplitudeTypes.CLICK_MORE_ELEMENTS, null);
        this.setState({
            redirectToElements: true
        });
    }

    onManufacturerClick = () => {
        this.props.history.push('/manufacturers');
    }

    onArticleClick = (item) => {
        if (!item) {
            this.props.history.push("/instructions/0");
        } else {
            this.props.history.push("/instruction/" + (item.pathKey ? item.pathKey : item.id));
        }
    }

    onIndividualProjectIdClick = (id) => {
        this.props.history.push('/home/productDetails/'+id);
    }

    onExecutorRegionClick = (id) => {
        localStorage.setItem("selectedRegionId", id);
        this.props.history.push("/kovanie-izdeliya-ceni");
    }

    render() {
        const { t, loading, failed, isAuthenticated, individualProjects, goods, elements, instructions, productsTypes, elementsCategories, executorRegions } = this.props;
        const isSmallScreen = window.innerWidth < 575;
        if (this.state.redirectToProjects) {
            return <Redirect to="/kovanie-izdeliya-ceni" />;
        }
        if (this.state.redirectToGoods) {
            return <Redirect to="/goods" />;
        }
        if (this.state.redirectToElements) {
            return <Redirect to="/kovanie-elementi-kovki" />;
        }
        return (
            <div className={!isMobile ? "container-home" : "container-home-mobile"} style={isTablet ? { backgroundImage: "url('/img/home/home_bg_tablet.jpg')" } : {}}>
                {(loading || this.state.loading) &&
                    <FullPageLoader />
                }
                {failed &&
                    <Alert color="danger">
                        {t('errorDataLoad')}
                    </Alert>
                }
                <Container className={!isMobile ? "container-full" : ""}>
                    {(!isMobile && !isSmallScreen) ?
                        <>
                            <Row className="m-0 p-0">
                                <Col className="h-container" xs="7">
                                    <img className="hrect" src="/img/home/h_hrect_full.png" />
                                    <div className="h-h1">{t('homeProject.h1')}</div>
                                    <div className="h-hul mt-4 mb-2">
                                        <div className="h-h3"><div className="h-li-point" />{t('homeProject.hli1')}</div>
                                        <div className="h-h3"><div className="h-li-point" />{t('homeProject.hli2')}</div>
                                        <div className="h-h3"><div className="h-li-point" />{t('homeProject.hli3')}</div>
                                    </div>
                                    {false && <Link to="/project/create">
                                        <Button color="success" style={{ height: "65px", width: "240px" }} onClick={this.onCreateProject}>
                                            {t('homeProject.createProject')}
                                        </Button></Link>
                                    }
                                    <Button color="success" style={{ height: "65px", width: "240px" }} onClick={this.onIndividualProjectClick}>
                                        {t('homeProject.openCatalog')}
                                    </Button>
                                    <br />
                                    {/*<Link to="/projectn/myprojects/0">
                                        <Button
                                            className="mt-2"
                                            color="success"
                                            outline
                                            style={{ height: "65px", width: "240px" }}
                                        >
                                            {t('homeProject.createProject')}
                                        </Button>
                                    </Link>*/}
                                </Col>
                                <Col className="h-container" xs="5">
                                    <img className="phone-image" src="/img/home/home_phone_full.png" />
                                </Col>
                            </Row>
                        </>
                        :
                        <div className="pl-2 pr-2">
                            <img className="hrect-mobile" src="/img/home/h_hrect_mobile.png" />
                            <div className="ml-3 mt-3">
                                <div className="h-h1-mobile">{t('homeProject.h1')}</div>
                                <div className="h-hul mt-4 mb-4">
                                    <div className="h-h3-mobile"><div className="h-li-point" />{t('homeProject.hli1')}</div>
                                    <div className="h-h3-mobile"><div className="h-li-point" />{t('homeProject.hli2')}</div>
                                    <div className="h-h3-mobile"><div className="h-li-point" />{t('homeProject.hli3')}</div>
                                </div>
                            </div>
                            {/*<Link to="/projectn/myprojects/0"><Button color="success">{t('homeProject.createProject')}</Button></Link>*/}
                            <Button color="success" onClick={this.onIndividualProjectClick}>
                                {t('homeProject.openCatalog')}
                            </Button>
                            <br />
                            <img src="/img/home/home_phone_mobile.png" />
                        </div>
                    }

                    <div className={!isMobile ? "h-contactphone" : "h-contactphone-mobile"}>
                        {isMobile ?
                            <a href="tel:+380951748378"><MdPhone size="1.2em" color="green" />+38(095)174-83-78</a>
                            :
                            <span>+38(095)174-83-78</span>
                        }
                    </div>

                    <Row>
                        <Col className="mb-3">
                            <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.howItWorks')}</b></div>
                            <HomeLine />
                        </Col>
                    </Row>
                    <div className="align-center" style={{ position: 'relative' }}>
                        <iframe
                            className="mt-1 mb-4"
                            type="text/html"
                            width="100%"
                            height="600"
                            src={`https://www.youtube.com/embed/${this.state.videoCode1}?autoplay=1&controls=0&disablekb=1&modestbranding=1&rel=0&mute=1&muted=1&loop=1&playlist=${this.state.videoCode1}`}
                            frameBorder="0"
                            allow='autoplay'
                        />
                        {!isMobile &&
                            <div className="h-videoHandleHider"></div>
                        }
                    </div>
                    <Row style={{ marginBottom: "50px" }}>                        
                        <Col className={!isMobile ? "align-center" : "div-info-block"}>
                            <Link to="/kovanie-izdeliya-ceni">
                                <img className={"shadowed " + (!isMobile ? "" : "img-info-mobile")} src="/img/home/h_vibor.png" />
                            </Link>
                            <div>
                                <div className="h-info-head">{t('homeProject.info.hp6_2')}</div>
                                <div className="h-info-text">{t('homeProject.info.p6_2')}</div>
                            </div>
                        </Col>
                        <Col className={!isMobile ? "align-center" : "div-info-block"}>
                            <Link to="/projectn/myprojects/0">
                                <img className={"shadowed " + (!isMobile ? "" : "img-info-mobile")} src="/img/home/h_mesurer.png" />
                            </Link>
                            <div>
                                <div className="h-info-head">{t('homeProject.info.hp6_1')}</div>
                                <div className="h-info-text">{t('homeProject.info.p6_1')}</div>
                            </div>
                        </Col>
                        <Col className={!isMobile ? "align-center" : "div-info-block"}>
                            <img className={!isMobile ? "" : "img-info-mobile"} src="/img/home/h_man_circle.png" />
                            <div>
                                <div className="h-info-head">{t('homeProject.info.hp6_3')}</div>
                                <div className="h-info-text">{t('homeProject.info.p6_3')}</div>
                            </div>
                        </Col>
                    </Row>

                    <div className="align-center">
                        <Link to="/instruction/kupit-kovanie-izdeliya">
                            <Button
                                color="success"
                                style={{ width: "300px", height: "60px", marginBottom: "50px" }}>
                                {t('homeProject.details')}
                            </Button>
                        </Link>
                    </div>

                    <div style={{ fontSize: !isMobile ? "40px" : "30px" }} className={isSmallScreen ? "mt-5" : ""} >
                        <b>{t('homeProject.info.hh1')}</b>
                    </div>
                    <HomeLine />
                    <Row className="mt-4">
                        <Col xs={!isMobile ? "6" : "auto"}>
                            <Row className="mb-4">
                                <Col xs="auto">
                                    <img className="h-info-img" src="/img/home/h_price.png" />
                                </Col>
                                <Col className="pl-0">
                                    <div className="h-info-head">{t('homeProject.info.hp1_5')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p1_5')}</div>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col xs="auto">
                                    <img className="h-info-img" src="/img/home/h_modeling.png" />
                                </Col>
                                <Col className="pl-0">
                                    <div className="h-info-head">{t('homeProject.info.hp1_1')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p1_1')}</div>
                                </Col>
                            </Row>                                                       
                        </Col>
                        <Col xs={!isMobile ? "6" : "auto"}>
                            <Row className="mb-4">
                                <Col xs="auto">
                                    <img className="h-info-img" src="/img/home/h_6.png" />
                                </Col>
                                <Col className="pl-0">
                                    <div className="h-info-head">{t('homeProject.info.hp1_3')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p1_3')}</div>
                                </Col>
                            </Row> 
                            <Row className="mb-4">
                                <Col xs="auto">
                                    <img className="h-info-img" src="/img/home/h_AR.png" />
                                </Col>
                                <Col className="pl-0">
                                    <div className="h-info-head">{t('homeProject.info.hp1_4')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p1_4')}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>                    

                    {/* individual projects */}
                    <div className="align-center">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.individualProjectsSketches')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    <div className="align-center">
                        <div className="mt-4 mb-4" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {individualProjects && individualProjects.map(proj => (
                                <div key={proj.id}>
                                    <Link to={`/kovanie-izdeliya-ceni/${proj.productTypeUrl}/${proj.id}`} style={{ textDecoration: 'none' }}>
                                        <ProductCard
                                            item={proj}
                                            t={t}
                                            isAuthenticated={isAuthenticated}
                                            addFavorites={this.props.addFavorites}
                                            removeFavorites={this.props.removeFavorites}
                                            loadFavoriteLocal={this.props.loadFavoriteLocal}
                                            onConstructorOpenClick={this.props.constructorOpenClick}
                                            isHomeCard={true}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </div>                        
                    </div>
                    <div className="align-center">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.individualProjects')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    {/*<div className="align-center">
                        <div className="mt-4 mb-4">
                            {individualProjects && individualProjects.map(proj => (
                                <IndividualProject
                                    key={proj.id}
                                    t={t}
                                    project={proj}
                                    onClick={() => this.onIndividualProjectClick(proj.typeKey)} />
                            ))}
                        </div>                        
                    </div>*/}
                    <div className="align-center">
                        <div className="mt-4 mb-4"> 
                            {productsTypes && productsTypes.map(prod => (
                                <div key={prod.id}  className={!isMobile ? "projItemNew" : "projItem-mNew"} onClick={() => this.props.push(prod.url ? "/kovanie-izdeliya-ceni/" + prod.url :"/kovanie-izdeliya-ceni" )} >
                                    <div className={!isMobile ? "projItem3dNew" : "projItem3d-mNew"}>
                                        <img style={{ width: '100%', maxHeight:"100%" }}
                                            src={prod.image} />
                                    </div>
                                    <div className="align-center" style={{ fontSize: "16px" }}><b>{prod.name}</b></div>
                                </div>
                            ))}
                        </div>
                        <Button
                            color="success"
                            style={{ width: "300px", height: "60px", marginBottom: "50px" }}
                            onClick={this.onIndividualProjectClick}>
                            {t('homeProject.moreProjects')}
                        </Button>
                    </div>

                </Container>

                <Container className={!isMobile ? "container-full mb-5" : "mb-5"}>

                    {/* elements */}
                    <div className="align-center mt-5">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.elements')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    {/*
                    <div className="align-center">
                        <div className="mt-4 mb-4">
                            {elements && elements.map(el => (
                                <ElementItem
                                    key={el.id}
                                    t={t}
                                    element={el}
                                    onClick={() => this.onElementClick(el)} />
                            ))}
                        </div>
                        <Button outline color="success" onClick={this.onElementClick}>{t('homeProject.moreElements')}</Button>
                    </div>*/}
                    <div className="align-center">
                        <div className="mt-4 mb-4">
                            {elementsCategories && elementsCategories.map(el => (
                                <div key={el.id} className={!isMobile ? "projItemNew" : "projItem-mNew"} onClick={() => this.props.push(el.url ? "/kovanie-elementi-kovki/" + el.url : "/kovanie-elementi-kovki")} >
                                    <div className={!isMobile ? "projItem3dNew" : "projItem3d-mNew"}>
                                        <img style={{ width: '100%', maxHeight:"100%" }}
                                            src={el.image} />
                                    </div>
                                    <div className="align-center" style={{ fontSize: "16px" }}><b>{el.name}</b></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>

                {/* goods */}
                <div className="h-bg-block">
                    <Container className={(!isMobile ? "container-full" : "") + "mt-3 pt-3 mb-3 pb-3"} >
                        <div className="align-center">
                            <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.goods')}</b></div>
                            <HomeLine className="self-center" />
                        </div>
                        <div className="align-center">
                            <div className="mt-4 mb-4">
                                {goods && goods.map(proj => (
                                    <GoodsItem
                                        key={proj.id}
                                        t={t}
                                        project={proj}
                                        onClick={() => this.onGoodsItemClick(proj)} />
                                ))}
                            </div>
                            <Button outline color="success" onClick={this.onGoodsItemClick}>{t('homeProject.moreGoods')}</Button>
                        </div>
                        <Row style={{ marginTop: "95px", marginBottom: "30px" }}>
                            <Col className="mb-3">
                                <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.howItWorks')}</b></div>
                                <HomeLine />
                            </Col>
                            <Col xs="auto" style={!isMobile ? { maxWidth: "480px" } : {}}>
                                <HomeGooglePlay t={t} />
                            </Col>
                        </Row>
                        {/*<iframe
                                className="e-player mb-3"
                                type="text/html"
                                width="100%"
                                height="600"
                                src={`https://www.youtube.com/embed/zp-IOcbrTLI`}
                                frameBorder="0"
                            />*/}
                        <Row>
                            <Col className={!isMobile ? "align-center" : "div-info-block"}>
                                <img className={!isMobile ? "" : "img-info-mobile"} src="/img/home/h_production.png" />
                                <div>
                                    <div className="h-info-head">{t('homeProject.info.hp4_1')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p4_1')}</div>
                                </div>
                            </Col>
                            <Col className={!isMobile ? "align-center" : "div-info-block"}>
                                <img className={!isMobile ? "" : "img-info-mobile"} src="/img/home/h_rendering.png" />
                                <div>
                                    <div className="h-info-head">{t('homeProject.info.hp4_2')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p4_2')}</div>
                                </div>
                            </Col>
                            <Col className={!isMobile ? "align-center" : "div-info-block"}>
                                <img className={!isMobile ? "" : "img-info-mobile"} src="/img/home/h_creditcard.png" />
                                <div>
                                    <div className="h-info-head">{t('homeProject.info.hp4_3')}</div>
                                    <div className="h-info-text">{t('homeProject.info.p4_3')}</div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* manufacturers */}
                <Container className={!isMobile ? "container-full mt-5 mb-3" : "mt-5 mb-3"}>
                    <div className="align-center">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.manufacturers')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    <div className="mt-3 mb-3" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                        {this.props.manufacturers && this.props.manufacturers.map(item => (
                            <ManufacturerItem key={item.id} item={item} />
                        ))}
                    </div>
                    <div className="align-center">
                        <Button outline color="success" onClick={this.onManufacturerClick}>{t('homeProject.moreManufacturers')}</Button>
                    </div>
                </Container>


                <Container className={!isMobile ? "container-full" : ""}>
                    <HomeFAQ t={t} />
                </Container>


                {/* articles */}
                <Container className={!isMobile ? "container-full mt-5" : "mt-5"}>
                    <div className="align-center">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.articleTitle')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    <div className="mt-3 mb-3" style={{ display: 'flex', justifyContent: 'center' }}>
                        {instructions && instructions.map(item => (
                            <div key={item.id} className="h-article-item" onClick={()=>this.onArticleClick(item)}>
                                <span><b>{item.title}</b></span>
                            </div>
                        ))}
                    </div>
                    <div className="align-center">
                        <Button outline color="success" onClick={()=>this.onArticleClick()}>{t('homeProject.moreArticle')}</Button>
                    </div>
                </Container>

                {/* executorRegions */}
                <Container className={!isMobile ? "container-full mt-5" : "mt-5"}>
                    <div className="align-center">
                        <div style={{ fontSize: !isMobile ? "40px" : "30px" }}><b>{t('homeProject.executorRegions')}</b></div>
                        <HomeLine className="self-center" />
                    </div>
                    <div className="mt-3 mb-3 regionMContainer">
                        {executorRegions && executorRegions.map(item => (
                            <div key={item.regionId} className="regionContainer" onClick={() => this.onExecutorRegionClick(item.regionId)}>
                                <span><b>{item.region}</b></span>
                                {item.cities.map((item2,itemIndex) => (
                                    <div key={itemIndex} className="citiesContainer">{item2}</div>
                                    ))}
                            </div>
                        ))}
                    </div>
                </Container>


                {this.state.showAfterDemoPopup &&
                    <Modal isOpen={true} toggle={this.hideAfterDemoPopup}>
                        <ModalBody className="pl-5 pr-5">
                            <div className="align-center">{t('homeProject.adpText')}</div>
                        </ModalBody>
                        <ModalFooter>
                            {isAuthenticated ?
                                <Link to="/project/create">
                                    <Button color="success" onClick={this.onCreateProjectAfterDemo}>{t('homeProject.createProject')}</Button>
                                </Link>
                                :
                                <Link to="/register">
                                    <Button color="success">{t('homeProject.adpRegister')}</Button>
                                </Link>
                            }
                            <Button color="secondary" onClick={this.cancelAfterDemo}>{t('homeProject.adpCancel')}</Button>
                        </ModalFooter>
                    </Modal>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.login.isAuthenticated,
    loading: state.home.loading,
    success: state.home.success,
    failed: state.home.failed,
    ...state.home.home,
    manufacturers: state.manufacturer.manufacturers
})

const mapDispatchToProps = {
    getHomeData: actions.getHomeData,
    makeDemoProduct: actions.makeDemoProduct,
    getInfoVideo: actions.getInfoVideo,
    getManufacturers: getManufacturers,
    push: push,
    addFavorites: addFavorites,
    removeFavorites: removeFavorites,
    loadFavoriteLocal: loadFavoriteLocal,
    constructorOpenClick: actions.constructorOpenClick,
}

export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps,
)(HomePage));